import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { handleError } from '../shared/utils/http';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import moment from 'moment';
import { AnonymizationService } from './anonymization.service';

@Injectable({
  providedIn: 'root',
})
export class MissionService {
  initialValue: boolean = false;
  refreshMissionSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    this.initialValue
  );

  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  constructor(private http: HttpClient, private router: Router,
  private anonymizationService: AnonymizationService // Add this line
) {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  toggleRefreshMission() {
    this.refreshMissionSource.next(!this.refreshMissionSource.value);
  }
  getFichePosteById(id: any) {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/fichePoste/${id}`
    );
  }
  getSites(candiatId: any) {
    return this.http.get(
      `${environment.api.BASE_URL}/etablissements/${candiatId}/sites`
    );
  }
  getRegions(): Observable<any> {
    return this.http.get(`${environment.api.REGIONS_URL}`);
  }
  getProfileRegions(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions/regions`);
  }
  getDepartment(): Observable<any> {
    return this.http.get(`${environment.api.DEPARTMENTS_URL}`);
  }
  getRefreshMission(): Observable<boolean> {
    return this.refreshMissionSource.asObservable();
  }

  getRefMission(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/generateMissionRef/${id}`
    );
  }

  getAffectationBySiteId(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/service-affectation/sites/${id}`
    );
  }

  refuMission(missionId: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/evaluation/refus/${missionId}`
    );
  }
  getMissions(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions`);
  }
  sendEval(body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/missions/evaluation`,
      body
    );
  }

  rejectMission(body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/missions/evaluation/rejected`,
      body
    );
  }

  get refreshMission(): boolean {
    return this.refreshMissionSource.getValue();
  }

  //getMissionsSonn(
  //  candidatId: any,
  //  typePosteId: any,
  //  offset: any = 0,
  //  size: any = 10
  //): Observable<any> {
  //  return this.http.get(
  //    `${environment.api.BASE_URL}/missions/soon/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
  //  );
  // }

  SoumettreMission(candidatId: number, missionId: number) {
    return this.http.post(
      `${environment.api.BASE_URL}/candidats/missions?candidatId=${candidatId}&missionId=${missionId}`,
      {}
    );
  }

  SoumettreFragmentMission(candidatId: number, missionId: number, period: { startDate: Date, endDate: Date }[] | null) {
    return this.http.post(
      `${environment.api.BASE_URL}/mission-fragment-candidatures`,
      {
        "missionId": +missionId,           // ID of the mission you want to apply for
        "candidatId": +candidatId,         // Your candidate ID
        "missionFragmentDates": period?.map((period) => ({
          startDate: moment(period?.startDate).add(1, 'hours').format('yyyy-MM-DDT00:00:00'), // Your desired start date
          endDate: moment(period?.endDate).add(1, 'hours').format('yyyy-MM-DDT00:00:00')    // Your desired end date
        }))
    }
    );
  }

  SignerMission(candidatId: number, missionId: number, preview: number) {
    return this.http.get(
      `${environment.api.BASE_URL}/generate/sign-url?candidatId=${candidatId}&missionId=${missionId}&preview=${preview}`,
      { responseType: 'text' }
    );
  }
  AnnulerMission(candidatId: number, missionId: number) {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/${missionId}/cancel/${candidatId}`
    );
  }
  SupprissionMission(body: any) {
    return this.http.put(`${environment.api.BASE_URL}/missions/archive`, body);
  }
  cancelMission(body: any) {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/signed/cancel`,
      body
    );
  }
  contestRejection(body: any) {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/finished/contestRejection`,
      body
    );
  }
  getActiveMissions(
    candidatId: any,
    typePosteId: any,

    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/started/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
    );
  }

  getFinishedMissions(
    candidatId: any,
    typePosteId: any,
    date: any,
    name: string,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      name && date
        ? `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?date=${date}&name=${name}&offset=${offset}&size=${size}`
        : name && !date
        ? `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?name=${name}&offset=${offset}&size=${size}`
        : date && !name
        ? `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?date=${date}&offset=${offset}&size=${size}`
        : `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?offset=${offset}&size=${size}`
    ).pipe(
      map((response: any) => {
        if (response && response['missions'] && Array.isArray(response['missions'])) {
          response['missions'] = this.anonymizationService.anonymizeMissionsIfNeeded(response['missions']);
        }
        return response;
      })
    );
  }

  getCurrentMissions(
    candidatId: any,
    typePosteId: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/current?offset=${offset}&size=${size}`
    ).pipe(
      map((response: any) => {
        if (response && response['missions'] && Array.isArray(response['missions'])) {
          response['missions'] = this.anonymizationService.anonymizeMissionsIfNeeded(response['missions']);
        }
        return response;
      })
    );
  }

   getNextConfirmedMission(
    candidatId: any
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/candidat/${candidatId}/nextConfirmed`
    );
  }

  getAcceuilMissions(
    candidatId: any,
    typePosteId: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
    );
  }
  getAcceuilMissionWithQuerry(
    candidatId: any,
    typePosteId: any,
    startDate: any,
    endDate: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/missions/available/current/pages?offset=${offset}&size=${size}`,
      {
        candidateId: candidatId,
        typePostId: typePosteId,
        startDate: startDate,
        endDate: endDate,
      }
    );
  }
  getMissionsByCondidat(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions/candidat/${id}`);
  }

  getMissionsByCondidatV2(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/v2/missions/candidat/${id}`);
  }

  getCandidateCalendar(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions/calendar/${id}`);
  }

  // getMissionsByCondidatIdAndMissionId(
  //  candidatId: any,
  //  missionId: any
  //): Observable<any> {
  //  return this.http.get(
  //    `${environment.api.BASE_URL}/missions/${missionId}/candidat/${candidatId}`
  //  );
  // }

  getRegionByCode(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/regionByCode?code=${id}`
    );
  }

  getMissionsByEtablissment(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/etablissements/${id}`);
  }

  getPostes(idSecteur: number): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/missions/secteurs/${idSecteur}/postes`)
      .toPromise()
      .catch(handleError);
  }

  getSecteurs(): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/missions/secteurs`)
      .toPromise()
      .catch(handleError);
  }

  getAllPostes(): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/missions/postes`)
      .toPromise()
      .catch(handleError);
  }

  getAffectationService(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/service-affectation`);
  }

  addMission(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/missions`, body);
  }

  draftMission(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/missions/draft`, body);
  }

  updateDraftMission(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/draft/${body.id}`,
      body
    );
  }
  updateDraftPublishMission(body: any): Observable<any> {
    const missionId = body.id;
    return this.http.put(
      `${environment.api.BASE_URL}/missions/draft/publish/${missionId}`,
      body
    );
  }

  deleteDraft(id: any): Observable<any> {
    return this.http.delete(`${environment.api.BASE_URL}/missions/${id}`);
  }

  missionFilter(body: any, offset: number = 0, size: number = 10): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/missions/filter/temporal?offset=${offset}&size=${size}`,
      body
    );
  }

  addGetAvailability(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/availability/${id}`);
  }

  addAvailability(id: any, body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/availability/${id}`,
      body
    );
  }

  addAvailableDay(id: any, body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/availability/${id}/add`,
      body
    );
  }

  getMissionsByEstablishmentId(body: any, id: number): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/etablissements/${id}/filter`,
      body
    );
  }

  updateCandidateStatus(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/candidats/decision`,
      body
    );
  }

  acceptCancelRequest(candidateId: number, missionId: number): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/signed/${missionId}/acceptCancellation/${candidateId}`,
      {}
    );
  }

  updateMissionStatus(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/evaluation/decision`,
      body
    );
  }

  deleteMission(missionId: number): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/missions/pending/cancel/${missionId}`,
      {}
    );
  }

  getMissionById(id: string, version = ""): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}${version}/missions/${id}`);
  }
  duplicateMission(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/missions/duplicate/${id}`
    );
  }

  updateActualWorkingHours(candidaId:number, missionId: number, dailyWorkingHours: Array<{
    workingDate: string,
    actualStartTime: string,
    actualEndTime: string,
    actualPauseMinutes?: number | null,
    comment?: string
  }>, status: string): Observable<any> {    
    return this.http.put(
      `${environment.api.BASE_URL}/imputation/actual-working-hours`,
      {
        candidaId,
        missionId: missionId,
        dailyWorkingHours: dailyWorkingHours,
        status
      }
    );
  }

  getActualWorkingHours(missionId: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/imputation/${missionId}/actual-working-hours`);
  }

  signAndSubmitWorkingHours(candidaId: number , missionId: number, dailyWorkingHours: Array<{
    workingDate: string,
    actualStartTime: string,
    actualEndTime: string,
    actualPauseMinutes?: number | null,
    comment?: string
  }>, status: string): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/imputation/${missionId}/signature`,
      {
        candidaId,
        missionId: missionId,
        dailyWorkingHours: dailyWorkingHours,
        status
      }
    );
  }

// Modify the methods that return mission data to apply anonymization
// For example, modify getMissionsByCondidatIdAndMissionId:

getMissionsByCondidatIdAndMissionId(candidatId: any, missionId: any, version= ""): Observable<any> {
  return this.http.get(
    `${environment.api.BASE_URL}${version}/missions/${missionId}/candidat/${candidatId}`
  ).pipe(
    map(mission => this.anonymizationService.anonymizeMissionIfNeeded(mission))
  );
}

// Similarly, modify other methods that return mission lists
getMissionsSonn(candidatId: any, typePosteId: any, offset: any = 0, size: any = 10): Observable<any> {
  return this.http.get(
    `${environment.api.BASE_URL}/missions/soon/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
  ).pipe(
    map((response: any) => {
      if (response && response['missions'] && Array.isArray(response['missions'])) {
        response['missions'] = this.anonymizationService.anonymizeMissionsIfNeeded(response['missions']);
      }
      return response;
    })
  );
}

// Apply the same pattern to other methods that return mission data

}
